export const login = {
  welcomeBack: 'Welcome Back',
  signInToContinue: 'Sign in to continue',
  continueWithGoogle: 'Continue with Google',
  continueWithApple: 'Continue with Apple',
  orContinueWithEmail: 'Or continue with email',
  emailAddress: 'Email Address',
  emailPlaceholder: 'your@email.com',
  password: 'Password',
  passwordPlaceholder: 'Enter your password',
  forgotPassword: 'Forgot password?',
  enterEmailToReset: 'Enter your email above first, then tap "Forgot password?".',
  resetEmailSent: 'Password reset link sent to {{email}}. Check your inbox.',
  signIn: 'Sign In',
  signingIn: 'Signing in...',
  dontHaveAccount: "Don't have an account?",
  signUp: 'Sign Up',
  copyright: '© 2026 Acework. All rights reserved.',
  createYourAccount: 'Create your account',
  alreadyHaveAccount: 'Already have an account?',
  creatingAccount: 'Creating account...',
  displayName: 'Display Name',
  displayNamePlaceholder: 'How others will see you',
  handle: 'Handle',
  handlePlaceholder: 'alex.johnson',
  handleHint: '3–20 chars · lowercase letters, numbers, dots and underscores · must start with a letter.',
  country: 'Country',
  countryPlaceholder: 'Select your country',
  countryRequired: 'Country is required',
  city: 'City',
  cityPlaceholder: 'Select your city',
  cityRequired: 'City is required',
  cityOther: 'Other...',
  cityOtherPlaceholder: 'Enter your city',
  countryAndCityRequired: 'Country and city are required',
};
